import { render, staticRenderFns } from "./FastbotAddExhangeModal.vue?vue&type=template&id=950ccce6&scoped=true"
import script from "./FastbotAddExhangeModal.vue?vue&type=script&lang=ts"
export * from "./FastbotAddExhangeModal.vue?vue&type=script&lang=ts"
import style0 from "./FastbotAddExhangeModal.vue?vue&type=style&index=0&id=950ccce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950ccce6",
  null
  
)

export default component.exports